var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"mt-4"},[_c('v-row',[_c('GoogleMap',{attrs:{"name":"locations","size":"big","addresses":_vm.data}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }